import { isValidEmail } from '../validation';

import { useSignupParams } from './useSignupParams';

export function useRecoverSignupByUrl() {
  const { email } = useSignupParams();

  return isValidEmail(email) ? email : null;
}
